import { Component, ElementRef, Optional } from '@angular/core';
import { SdkWrapperModuleConfigService } from '../../service/sdk-wrapper-module-config.service';
import { BpSdkBusinessClassificationSelectorComponent } from '../bp-sdk-business-classification-selector/bp-sdk-business-classification-selector.component';

@Component({
  selector: 'emperor-bp-sdk-slim-business-class-selector',
  templateUrl: './bp-sdk-slim-business-class-selector.component.html',
  styleUrls: ['./bp-sdk-slim-business-class-selector.component.scss'],
})
export class BpSdkSlimBusinessClassSelectorComponent extends BpSdkBusinessClassificationSelectorComponent {
  constructor(
    elRef: ElementRef,
    @Optional() sdkWrapperModuleConfigService: SdkWrapperModuleConfigService,
  ) {
    super(elRef, sdkWrapperModuleConfigService);
  }

  userHasFocused = false;

  clearPopup() {
    this.hasBusinessClassFilter = false;
    this.userHasFocused = false;
  }

  focusInput() {
    this.userHasFocused = true;
    if (!this.hasBusinessClassFilter)
      this.updateListOfNaics(this.formControl.value);
  }

  onUpdateValue(event) {
    super.onUpdateValue(event);
    this.clearPopup();
  }

  protected updateListOfNaics(search: string | null): void {
    this.hasBusinessClassFilter =
      !!search && search.length > 0 && this.userHasFocused;

    if (this.hasBusinessClassFilter) {
      this.loadingBcsChoices = true;

      this.elRef.nativeElement.dispatchEvent(
        new CustomEvent('filterUpdate', {
          detail: {
            value: search,
            id: this.questionId,
          },
          bubbles: true,
        }),
      );
    }
  }

  clearSearch(): void {
    super.clearSearch();
    this.elRef.nativeElement.dispatchEvent(
      new CustomEvent('valueUpdate', { bubbles: true, detail: [''] }),
    );
  }
}
